
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class GuidePage extends Vue {
  toIndex() {
    this.$router.push('index');
  }
}
